import React from "react";
import Register from "../../components/Auth/Register";

const RegisterPage = () => {
    return <div><Register /></div>;
};

export default RegisterPage;
